module.exports = __webpack_public_path__ + "static/media/archive.3bb0c357.svg";